const dashboard = () => import(/* webpackPrefetch: true */ '@/views/private/index.vue')
const profile = () => import(/* webpackPrefetch: true */ '@/views/private/profile/index.vue')

const menu = () => import(/* webpackPrefetch: true */ '@/views/private/menu.vue')
const user = () => import(/* webpackPrefetch: true */ '@/views/private/user/index.vue')
const user_detail = () => import(/* webpackPrefetch: true */ '@/views/private/user/_id.vue')
const user_add = () => import(/* webpackPrefetch: true */ '@/views/private/user/add/index.vue')
const user_edit = () => import(/* webpackPrefetch: true */ '@/views/private/user/edit/_id.vue')


const category_user = () => import(/* webpackPrefetch: true */ '@/views/private/category-user/index.vue')
const category_user_add = () => import(/* webpackPrefetch: true */ '@/views/private/category-user/add/index.vue')
const category_user_edit = () => import(/* webpackPrefetch: true */ '@/views/private/category-user/edit/_id.vue')


const client = () => import(/* webpackPrefetch: true */ '@/views/private/client.vue')

const audit = () => import(/* webpackPrefetch: true */ '@/views/private/audit/index.vue')

const config = () => import(/* webpackPrefetch: true */ '@/views/private/config/index.vue')

const vendor = () => import(/* webpackPrefetch: true */ '@/views/private/vendor-data/index.vue')

const ahsp = () => import(/* webpackPrefetch: true */ '@/views/private/ahsp/index.vue')

const master_ahsp = () => import(/* webpackPrefetch: true */ '@/views/private/master-ahsp/index.vue')


const project = () => import(/* webpackPrefetch: true */ '@/views/private/project/index.vue')
const project_detail = () => import(/* webpackPrefetch: true */ '@/views/private/project/_id.vue')
const project_add = () => import(/* webpackPrefetch: true */ '@/views/private/project/add/index.vue')
const project_edit = () => import(/* webpackPrefetch: true */ '@/views/private/project/edit/_id.vue')
const project_process = () => import(/* webpackPrefetch: true */ '@/views/private/project/process.vue')
const project_process_persiapan = () => import(/* webpackPrefetch: true */ '@/views/private/project/process/persiapan/_id.vue')
const project_process_penawaran = () => import(/* webpackPrefetch: true */ '@/views/private/project/process/penawaran/_id.vue')
const project_process_negosiasi = () => import(/* webpackPrefetch: true */ '@/views/private/project/process/negosiasi/_id.vue')
const project_process_pelaksanaan = () => import(/* webpackPrefetch: true */ '@/views/private/project/process/pelaksanaan/_id.vue')
const project_pelaksanaan = () => import(/* webpackPrefetch: true */ '@/views/private/project/pelaksanaan.vue')
const project_pelaksanaan_informasi = () => import(/* webpackPrefetch: true */ '@/views/private/project/pelaksanaan/informasi/_id.vue')
const project_pelaksanaan_cco = () => import(/* webpackPrefetch: true */ '@/views/private/project/pelaksanaan/cco/_id.vue')
const project_pelaksanaan_ceklist_kemajuan_pekerjaan = () => import(/* webpackPrefetch: true */ '@/views/private/project/pelaksanaan/ceklist-kemajuan-pekerjaan/_id.vue')
const project_pelaksanaan_kemajuan_pekerjaan = () => import(/* webpackPrefetch: true */ '@/views/private/project/pelaksanaan/kemajuan-pekerjaan/_id')
const project_pelaksanaan_realisasi_belanja = () => import(/* webpackPrefetch: true */ '@/views/private/project/pelaksanaan/realisasi-belanja/_id')
const project_pelaksanaan_realisasi_kebutuhan = () => import(/* webpackPrefetch: true */ '@/views/private/project/pelaksanaan/realisasi-kebutuhan/_id')
const project_pelaksanaan_rencana_belanja = () => import(/* webpackPrefetch: true */ '@/views/private/project/pelaksanaan/rencana-belanja/_id')
const project_pelaksanaan_rencana_kebutuhan = () => import(/* webpackPrefetch: true */ '@/views/private/project/pelaksanaan/rencana-kebutuhan/_id')
const project_evaluasi_pembayaran = () => import(/* webpackPrefetch: true */ '@/views/private/project/evaluasi-pembayaran.vue')
const project_evaluasi_pembayaran_surat_acara = () => import(/* webpackPrefetch: true */ '@/views/private/project/evaluasi-pembayaran/surat-acara/_id')
const project_evaluasi_pembayaran_berita_acara = () => import(/* webpackPrefetch: true */ '@/views/private/project/evaluasi-pembayaran/berita-acara/_id')
const project_evaluasi_pembayaran_tahap_pembayaran = () => import(/* webpackPrefetch: true */ '@/views/private/project/evaluasi-pembayaran/tahap-pembayaran/_id')
const project_evaluasi_pembayaran_ketentuan_pembayaran = () => import(/* webpackPrefetch: true */ '@/views/private/project/evaluasi-pembayaran/ketentuan-pembayaran/_id')
const project_pengadaan_pembayaran = () => import(/* webpackPrefetch: true */ '@/views/private/project/pengadaan-pembayaran/_id')



const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: dashboard,
    meta: {
      title: "Dashboard"
    }
  },

  {
    path: "/profile",
    name: "Profile",
    component: profile,
    meta: {
      title: "Profile"
    }
  },

  {
    path: "/menu",
    name: "Menu",
    component: menu,
    meta: {
      title: "Menu"
    }
  },

  {
    path: "/user",
    name: "User",
    component: user,
    meta: {
      title: "User"
    }
  },

  {
    path: "/user/detail/:id",
    name: "User Detail",
    component: user_detail,
    meta: {
      title: "User Detail"
    }
  },

  {
    path: "/user/add",
    name: "User Add",
    component: user_add,
    meta: {
      title: "User Add"
    }
  },

  {
    path: "/user/edit/:id",
    name: "User Edit",
    component: user_edit,
    meta: {
      title: "User Edit"
    }
  },

  {
    path: "/category-user",
    name: "Category User",
    component: category_user,
    meta: {
      title: "Kategori User"
    }
  },

  {
    path: "/category-user/add",
    name: "Category User Add",
    component: category_user_add,
    meta: {
      title: "Tambah Kategori User"
    }
  },

  {
    path: "/category-user/edit/:id",
    name: "Category User Edit",
    component: category_user_edit,
    meta: {
      title: "Ubah Kategori User"
    }
  },

  {
    path: "/client",
    name: "Client",
    component: client,
    meta: {
      title: "Client"
    }
  },

  {
    path: "/audit",
    name: "Audit",
    component: audit,
    meta: {
      title: "Audit"
    }
  },
  {
    path: "/config",
    name: "Config",
    component: config,
    meta: {
      title: "Config"
    }
  },
  {
    path: "/vendor",
    name: "Vendor",
    component: vendor,
    meta: {
      title: "Vendor"
    }
  },

  {
    path: "/project",
    name: "Project",
    component: project,
    meta: {
      title: "Project"
    }
  },

  {
    path: "/project/detail/:id",
    name: "Project Detail",
    component: project_detail,
    meta: {
      title: "Project Detail"
    }
  },

  {
    path: "/project/add",
    name: "Project Add",
    component: project_add,
    meta: {
      title: "Project Add"
    }
  },

  {
    path: "/project/edit/:id",
    name: "Project Edit",
    component: project_edit,
    meta: {
      title: "Project Edit"
    }
  },

  {
    path: "/project/process",
    name: "Project Process",
    component: project_process,
    meta: {
      title: "Project Process"
    },
    children: [
      {
        path: "/project/process/persiapan/:id",
        name: "Project Process Persiapan",
        component: project_process_persiapan,
        meta: {
          title: "Project Process Persiapan"
        }
      },
      {
        path: "/project/process/penawaran/:id",
        name: "Project Process Penawaran",
        component: project_process_penawaran,
        meta: {
          title: "Project Process Penawaran"
        }
      },
      {
        path: "/project/process/negosiasi/:id",
        name: "Project Process Negosiasi",
        component: project_process_negosiasi,
        meta: {
          title: "Project Process Negosiasi"
        }
      },
      {
        path: "/project/process/pelaksanaan/:id",
        name: "Project Process Pelaksanaan",
        component: project_process_pelaksanaan,
        meta: {
          title: "Project Process Pelaksanaan"
        }
      },
    ]
  },

  {
    path: "/project/pelaksanaan",
    name: "Project Pelaaksanaan",
    component: project_pelaksanaan,
    meta: {
      title: "Project Pelaksanaan"
    },
    children: [
      {
        path: "/project/pelaksanaan/informasi/:id",
        name: "Project Informasi Pelaksanaan",
        component: project_pelaksanaan_informasi,
        meta: {
          title: "Project Informasi Pelaksanaan"
        }
      },
      {
        path: "/project/pelaksanaan/cco/:id",
        name: "Project CCO Pelaksanaan",
        component: project_pelaksanaan_cco,
        meta: {
          title: "Project CCO Pelaksanaan"
        }
      },
      {
        path: "/project/pelaksanaan/ceklist-kemajuan-pekerjaan/:id",
        name: "Project Ceklist Kemajuan Pekerjaan Pelaksanaan",
        component: project_pelaksanaan_ceklist_kemajuan_pekerjaan,
        meta: {
          title: "Project Ceklist Kemajuan Pekerjaan Pelaksanaan"
        }
      },
      {
        path: "/project/pelaksanaan/kemajuan-pekerjaan/:id",
        name: "Project Kemajuan Pekerjaan Pelaksanaan",
        component: project_pelaksanaan_kemajuan_pekerjaan,
        meta: {
          title: "Project Kemajuan Pekerjaan Pelaksanaan"
        }
      },
      {
        path: "/project/pelaksanaan/realisasi-belanja/:id",
        name: "Project Realisasi Belanja Pelaksanaan",
        component: project_pelaksanaan_realisasi_belanja,
        meta: {
          title: "Project Realisasi Belanja Pelaksanaan"
        }
      },
      {
        path: "/project/pelaksanaan/realisasi-kebutuhan/:id",
        name: "Project Realisasi Kebutuhan Pelaksanaan",
        component: project_pelaksanaan_realisasi_kebutuhan,
        meta: {
          title: "Project Realisasi Kebutuhan Pelaksanaan"
        }
      },
      {
        path: "/project/pelaksanaan/rencana-belanja/:id",
        name: "Project Rencana Belanja Pelaksanaan",
        component: project_pelaksanaan_rencana_belanja,
        meta: {
          title: "Project Rencana Belanja Pelaksanaan"
        }
      },
      {
        path: "/project/pelaksanaan/rencana-kebutuhan/:id",
        name: "Project Rencana Kebutuhan Pelaksanaan",
        component: project_pelaksanaan_rencana_kebutuhan,
        meta: {
          title: "Project Rencana Kebutuhan Pelaksanaan"
        }
      },
    ]
  },

  {
    path: "/project/evaluasi-pembayaran",
    name: "Project Evaluasi Pembayaran",
    component: project_evaluasi_pembayaran,
    meta: {
      title: "Project Evaluasi Pembayaran"
    },
    children: [
      {
        path: "/project/evaluasi-pembayaran/surat-berita-acara/:id",
        name: "Project Surat Berita Acara Evaluasi Pembayaran",
        component: project_evaluasi_pembayaran_surat_acara,
        meta: {
          title: "Project Surat Berita Acara Evaluasi Pembayaran"
        }
      },
      {
        path: "/project/evaluasi-pembayaran/berita-acara/:id",
        name: "Project Berita Acara Evaluasi Pembayaran",
        component: project_evaluasi_pembayaran_berita_acara,
        meta: {
          title: "Project Berita Acara Evaluasi Pembayaran"
        }
      },
      {
        path: "/project/evaluasi-pembayaran/tahap-pembayaran/:id",
        name: "Project Tahap Pembayaran Evaluasi Pembayaran",
        component: project_evaluasi_pembayaran_tahap_pembayaran,
        meta: {
          title: "Project Tahap Pembayaran Evaluasi Pembayaran"
        }
      },
      {
        path: "/project/evaluasi-pembayaran/ketentuan-pembayaran/:id",
        name: "Project Ketentuan Pembayaran Evaluasi Pembayaran",
        component: project_evaluasi_pembayaran_ketentuan_pembayaran,
        meta: {
          title: "Project Ketentuan Pembayaran Evaluasi Pembayaran"
        }
      },
    ]
  },

  {
    path: "/project/pengadaan-pembayaran/:id",
    name: "Pengadaan dan Pembayaran Project",
    component: project_pengadaan_pembayaran,
    meta: {
      title: "Pengadaan dan Pembayaran Project"
    }
  },


  {
    path: "/ahsp",
    name: "Master harga satuan",
    component: ahsp,
    meta: {
      title: "Master harga satuan"
    }
  },

  {
    path: "/master-ahsp",
    name: "Master AHSP",
    component: master_ahsp,
    meta: {
      title: "Master AHSP"
    }
  },
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})